import React, { useMemo } from 'react';
import { Card, Grid, Group, NumberInput, Text, TextInput, ThemeIcon } from '@mantine/core';
import { IconBox, IconPackage } from '@tabler/icons-react';
import { TarjetaTablaEditable } from '../../../../globales/componentes/tabla/tarjetaTablaEditable';
import type { ITablaEditable } from '../../../../globales/componentes/tabla/useEdicionFilas';
import type { ICotizacionPostventa, IRepuestoPostventa } from '../../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';
import { columnasRepuestos } from '../constantesTablasCostosPostventa';
import { formatoMoneda, type CampoCotizacionPostventa } from '../../interfaces';

interface PasoRepuestosVistaProps {
    cotizacion: ICotizacionPostventa;
    repuestos: ITablaEditable<IRepuestoPostventa>;
    incoterms: { value: string; label: string }[];
    alCambiar: (campo: CampoCotizacionPostventa, valor: string | number) => void;
}

/** Paso 2: repuestos por unidad y embalaje (guacal). */
export const PasoRepuestosVista: React.FC<PasoRepuestosVistaProps> = ({ cotizacion, repuestos, incoterms, alCambiar }) => {
    const resultado = cotizacion.Resultado;
    const columnas = useMemo(
        () => columnasRepuestos(incoterms, (r) => resultado?.SubtotalesRepuestos.find(s => s.RepuestoId === r.Id)?.Subtotal),
        [incoterms, resultado]
    );

    return (
        <Grid gutter="md">
            <Grid.Col span={12}>
                <TarjetaTablaEditable
                    titulo="Repuestos por Unidad"
                    icono={<IconPackage size={18} />}
                    nota="El costo unitario va en la divisa de compra; si ya está en pesos, la TRM es 1."
                    tabla={repuestos}
                    columnas={columnas}
                    minWidth={1000}
                    pie={
                        <Group justify="flex-end" gap="xs">
                            <Text size="sm" c="dimmed">Total repuestos por unidad:</Text>
                            <Text size="sm" fw={700}>{resultado ? formatoMoneda(resultado.Costos.Repuestos) : '-'}</Text>
                        </Group>
                    }
                />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6 }}>
                <Card shadow="sm" p="md" radius="md" withBorder>
                    <Group gap="xs" mb="sm">
                        <ThemeIcon variant="light" color="primary" radius="xl" size="md"><IconBox size={18} /></ThemeIcon>
                        <Text fw={600} size="md">Guacal (escenario máximo)</Text>
                    </Group>
                    <Grid>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <NumberInput size="xs" label="Peso de la carga" min={0} allowNegative={false} hideControls suffix=" kg" thousandSeparator="." decimalSeparator="," value={cotizacion.PesoGuacalKg} onChange={(v) => alCambiar('PesoGuacalKg', v === '' ? '' : Number(v))} />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <TextInput size="xs" label="Dimensiones" placeholder="Largo × ancho × alto" maxLength={50} value={cotizacion.DimensionesGuacal} onChange={(e) => alCambiar('DimensionesGuacal', e.currentTarget.value)} />
                        </Grid.Col>
                    </Grid>
                </Card>
            </Grid.Col>
        </Grid>
    );
};
